export const TRUELAYER_ERROR_ABANDONED_VALUE = 'tl_hpp_abandoned';
